var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 345,
    viewBox: "0 0 288 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231.988 232.467H269.783C271.355 232.466 272.88 231.93 274.108 230.947C275.335 229.964 276.191 228.594 276.537 227.06L284.773 190.349C285 189.337 284.997 188.287 284.763 187.277C284.53 186.266 284.072 185.321 283.424 184.512C282.775 183.702 281.953 183.049 281.018 182.6C280.083 182.151 279.059 181.918 278.022 181.919",
    stroke: "#6562CF",
    strokeWidth: 1.34579,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.276 232.467H200.071C201.643 232.466 203.168 231.93 204.396 230.947C205.623 229.964 206.479 228.594 206.824 227.06L215.061 190.349C215.288 189.337 215.285 188.287 215.051 187.277C214.818 186.266 214.36 185.321 213.712 184.512C213.063 183.702 212.241 183.049 211.306 182.6C210.371 182.151 209.347 181.918 208.31 181.919",
    stroke: "#6562CF",
    strokeWidth: 1.34579,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203.643 194.871H267.783C270.118 194.871 272.383 194.081 274.212 192.629C276.04 191.178 277.323 189.15 277.853 186.877L287.095 147.181C287.625 144.903 287.229 142.507 285.993 140.521C284.756 138.535 282.782 137.121 280.504 136.59C279.848 136.438 279.177 136.362 278.504 136.361H214.361C212.027 136.361 209.761 137.151 207.933 138.603C206.106 140.054 204.823 142.082 204.294 144.355L195.051 184.059C194.751 185.352 194.747 186.696 195.04 187.991C195.332 189.286 195.912 190.499 196.738 191.538C197.564 192.577 198.614 193.417 199.809 193.994C201.005 194.571 202.315 194.871 203.643 194.871V194.871Z",
    fill: "white",
    stroke: "#6562CF",
    strokeWidth: 1.34579,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M263.208 223.31H160.338C159.124 223.31 157.961 223.792 157.102 224.651C156.244 225.509 155.762 226.673 155.762 227.886V227.886C155.762 229.1 156.244 230.263 157.102 231.122C157.961 231.98 159.124 232.462 160.338 232.462H263.208C264.421 232.462 265.585 231.98 266.443 231.122C267.301 230.263 267.783 229.1 267.783 227.886V227.886C267.783 226.673 267.301 225.509 266.443 224.651C265.585 223.792 264.421 223.31 263.208 223.31V223.31Z",
    fill: "#EAEEFF",
    stroke: "#6562CF",
    strokeWidth: 1.34579,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M275.436 336.556L262.664 241.376C262.419 236.383 258.484 232.467 253.712 232.467H231.641C226.869 232.467 222.933 236.383 222.686 241.376L209.914 336.556",
    stroke: "#6562CF",
    strokeWidth: 1.34579,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194.322 232.467H172.891C168.259 232.467 164.437 236.383 164.198 241.376L151.561 336.556",
    stroke: "#6562CF",
    strokeWidth: 1.34579,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1939 138.151C91.8023 139.069 88.5751 145.906 88.5159 146.729C88.4567 147.553 92.163 153.674 92.163 153.674C92.163 153.674 93.6353 153.706 93.9152 150.339C94.257 146.352 96.0066 144.843 98.542 144.275C99.6025 144.038 101.551 144.845 101.689 146.406C101.826 147.967 97.7938 149.004 96.9836 149.951C95.7536 151.383 96.4453 153.402 96.4453 153.45C96.4453 153.45 102.668 151.566 103.863 151.216C104.94 150.896 109.747 146.525 112.746 142.191C113.861 143.008 115.03 143.75 116.245 144.412C123.781 148.465 149.62 157.894 163.006 155.757C176.447 153.604 165.697 110.807 165.697 110.807C146.232 111.706 138.081 109.227 136.596 108.703L139.618 128.486C131.439 128.243 111.311 131.578 111.3 131.581C105.659 132.324 95.1937 136.835 93.1939 138.151Z",
    fill: "#F1921B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.805 110.789H165.689C146.223 111.688 138.073 109.209 136.587 108.684L137.301 113.529C137.301 113.529 151.741 120.328 167.802 119.719L165.805 110.789Z",
    fill: "#EB7200"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.853 164.884C159.229 164.545 150.847 110.735 150.847 110.735C140.525 110.886 128.044 106.07 128.044 106.07C128.044 106.07 136.579 78.0994 139.521 72.3313C142.463 66.5632 163.581 56.5909 166.074 55.8695L207.239 46.449C207.239 46.449 242.378 55.1778 253.459 64.1354C264.54 73.093 273.199 110.878 273.199 110.878C252.848 119.084 231.749 117.876 231.749 117.876L238.922 161.111C241.244 171.608 248.665 204.935 235.581 221.117C235.581 221.117 225.055 169.379 163.853 164.884Z",
    fill: "#EAEEFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190.907 60.2918L203.218 67.8041L218.829 49.652L207.11 42.6323C206.426 42.2252 205.608 42.1063 204.837 42.3016C204.065 42.4969 203.402 42.9905 202.994 43.674C202.994 43.6874 202.981 43.6982 202.976 43.7089L190.907 60.2918Z",
    fill: "#DBDAFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.184 62.0143L163.52 67.1284L163.937 56.7334L166.074 55.8694C166.074 55.8694 169.88 58.4211 172.184 62.0143Z",
    fill: "#DBDAFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M231.748 117.87C230.08 112.404 228.411 99.1987 228.411 99.1987",
    stroke: "#C7BFFF",
    strokeWidth: 1.34579,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M203.218 67.8039L191.138 60.7493C191.138 60.7493 179.548 74.5383 179.225 76.95C178.902 79.3616 178.294 103.955 178.294 103.955H172.184",
    stroke: "#C7BFFF",
    strokeWidth: 1.34579,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M163.748 67.1176L171.955 62.4719C171.955 62.4719 179.397 74.245 179.222 76.95",
    stroke: "#C7BFFF",
    strokeWidth: 1.34579,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M230.438 112.439C230.438 112.439 256.449 113.211 271.737 105.066",
    stroke: "#C7BFFF",
    strokeWidth: 1.34579,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M152.616 155.035C152.616 156.271 165.304 155.821 167.091 155.821C168.878 155.821 180.073 156.247 182.702 155.821C196.997 156.998 260.758 161.633 268.174 151.326C276.757 139.392 269.089 112.395 269.089 112.395C249.831 119.084 231.748 117.867 231.748 117.867L233.328 128.12C218.043 130.004 190.46 139.693 181.082 143.088C179.071 142.444 171.417 140.127 167.541 141.01C163.056 142.019 157.671 146.056 157.111 147.179C156.551 148.301 152.616 153.803 152.616 155.035Z",
    fill: "#F1921B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M167.099 155.821C165.312 155.821 152.624 156.271 152.624 155.038C152.624 153.806 156.551 148.309 157.111 147.187C157.67 146.065 163.054 142.027 167.54 141.018C167.54 141.018 162.004 148.708 167.099 155.821",
    fill: "#EB7200"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M269.1 112.403C269.1 112.403 249.389 119.337 231.749 117.87L233.329 128.12C233.329 128.12 256.869 124.351 269.934 115.824L269.1 112.403Z",
    fill: "#EB7200"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5709 337.525H142.156C142.199 336.861 142.215 336.225 142.202 335.614H98.5143C98.4658 336.252 98.4847 336.892 98.5709 337.525V337.525Z",
    fill: "#3F4D79"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M137.714 318.011C137.558 322.765 142.153 325.777 142.153 335.601H98.5706C98.5706 335.601 97.9381 327.359 106.645 325.459C115.353 323.559 123.277 321.021 124.084 318.011H137.714Z",
    fill: "#FFB000"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M123.781 326.891L119.802 321.002",
    stroke: "#3F4D79",
    strokeWidth: 1.34579,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M120.677 327.607L116.935 322.197",
    stroke: "#3F4D79",
    strokeWidth: 1.34579,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M116.618 327.846L113.593 322.913",
    stroke: "#3F4D79",
    strokeWidth: 1.34579,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M184.586 168.693C184.586 168.693 118.067 164.532 101.901 183.55C85.7352 202.569 117.114 270.397 120.284 311.603C120.284 311.603 136.202 313.188 142.665 311.603C149.128 310.017 154.753 239.57 138.469 220.234C138.469 220.234 200.375 234.475 224.516 216.514C248.657 198.553 194.629 169.032 184.586 168.693Z",
    fill: "#3C4564"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M124.085 318.011C128.505 319.505 133.293 319.505 137.713 318.011L139.002 312.133C139.002 312.133 130.534 312.561 122.798 311.821L124.085 318.011Z",
    fill: "#F1921B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0809777 271.527L34.6544 298.064C35.1443 297.466 35.5866 296.882 35.9814 296.312L1.54519 269.88C0.996052 270.372 0.504816 270.924 0.0809777 271.527V271.527Z",
    fill: "#3F4D79"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2755 279.734C40.2555 283.411 42.0697 288.598 36.0863 296.392L1.51279 269.856C1.51279 269.856 6.02929 262.933 14.1014 266.731C22.1734 270.529 30.0033 273.344 32.4661 271.436L43.2755 279.734Z",
    fill: "#FFB000"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7248 277.874L27.1528 271.013",
    stroke: "#3F4D79",
    strokeWidth: 1.34579,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.098 276.203L24.526 270.058",
    stroke: "#3F4D79",
    strokeWidth: 1.34579,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4712 274.531L21.8991 269.102",
    stroke: "#3F4D79",
    strokeWidth: 1.34579,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M235.581 218.425C234.585 223.792 177.981 236.798 117.749 198.777C117.749 198.777 113.789 244.641 52.9299 277.909C52.9299 277.909 39.6873 273.129 33.7362 262.624C33.7362 262.624 73.4371 216.197 88.7227 173.562C95.1394 155.66 175.901 165.032 187.709 168.693C199.517 172.353 240.02 194.505 235.581 218.425Z",
    fill: "#3F4D79"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4658 271.436C32.4658 271.436 35.074 279.468 43.2753 279.734L48.6208 275.944C43.7871 273.474 39.4882 270.074 35.9703 265.94L32.4658 271.436Z",
    fill: "#F1921B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M183.569 31.6532C183.569 31.6532 186.086 38.2691 202.41 44.5728C202.41 44.5728 190.922 60.297 179.238 75.0712C179.238 75.0712 174.555 61.4975 166.09 55.8748L183.569 31.6532Z",
    fill: "#F1921B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M166.074 55.8694C168.569 57.5732 170.671 59.8745 172.41 62.3292C177.793 58.2918 183.846 51.2049 185.639 46.0639C186.525 43.5204 184.18 36.6434 182.821 32.6706L166.074 55.8694Z",
    fill: "#EB7200"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M183.897 32.9451C183.897 35.0984 185.768 41.7278 183.504 44.3871C179.365 49.2508 167.506 57.0375 161.673 56.7119C157.517 56.4885 151.631 38.4602 150.753 35.7659C149.876 33.0716 146.086 22.2676 148.778 19.3795C151.469 16.4914 173.968 10.1716 178.439 19.4791C183.394 29.796 183.897 32.9451 183.897 32.9451Z",
    fill: "#F1921B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M139.521 13.1133C141.731 27.5698 151.146 29.4593 169.694 18.6014C178.191 13.63 172.184 22.5338 176.961 30.2641L178.523 30.8454C178.471 30.0676 178.361 26.8538 179.96 26.8457C182.315 26.8457 183.039 30.4094 183.265 32.6084L184.169 32.9449C184.169 32.9449 184.266 16.8303 181.981 11.7083C176.329 -0.971822 159.991 5.87827 155.983 8.03423C143.338 14.8305 139.521 13.1133 139.521 13.1133Z",
    fill: "#FFB000"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M170.111 17.4952C156.922 27.9063 146.56 30.3745 141.414 24.2538",
    stroke: "#FFB000",
    strokeWidth: 1.07664,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M188.48 26.3136L189.212 28.8869C190.11 32.0439 188.279 35.3312 185.122 36.2293L185.096 36.2366C181.939 37.1347 178.652 35.3036 177.754 32.1466L177.021 29.5732C176.123 26.4162 177.955 23.129 181.112 22.2309L181.137 22.2235C184.294 21.3254 187.582 23.1566 188.48 26.3136Z",
    fill: "white",
    stroke: "#3F4D79",
    strokeWidth: 1.34579,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M176.803 28.8001L177.981 32.9452C178.166 33.593 178.476 34.1981 178.894 34.726C179.312 35.254 179.83 35.6943 180.419 36.022C181.007 36.3497 181.654 36.5583 182.323 36.6358C182.992 36.7133 183.67 36.6583 184.317 36.4739L185.911 36.019C185.981 36.0001 186.048 35.9786 186.118 35.9544C184.832 36.2659 183.475 36.0668 182.333 35.3987C181.19 34.7306 180.351 33.6456 179.992 32.3719L178.813 28.2268C178.449 26.9552 178.591 25.5918 179.21 24.4229C179.83 23.254 180.878 22.3706 182.135 21.9581L181.925 22.012L180.339 22.4588C179.033 22.8241 177.926 23.6931 177.261 24.8747C176.596 26.0563 176.427 27.4538 176.792 28.7598C176.794 28.7732 176.8 28.8001 176.803 28.8001Z",
    fill: "white",
    stroke: "#3F4D79",
    strokeWidth: 1.34579,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M181.924 22.0039L177.08 4.99304C176.866 4.24224 176.507 3.54084 176.022 2.92889C175.538 2.31694 174.938 1.80643 174.256 1.42652C173.574 1.0466 172.824 0.804723 172.048 0.714696C171.273 0.624669 170.488 0.688256 169.737 0.901826V0.901826L152.511 5.80052C150.379 6.40612 149.41 8.08837 150.018 10.2228",
    stroke: "#3F4D79",
    strokeWidth: 1.34579,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M101.443 156.5H176.967C180.415 156.5 182.6 153.052 180.937 150.236L155.367 106.991C153.143 103.222 148.907 100.892 144.288 100.892H68.7621C65.3142 100.892 63.1286 104.339 64.792 107.155L90.3621 150.401C92.5934 154.163 96.8354 156.5 101.443 156.5Z",
    fill: "#EAEEFF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M102.184 157.889H174.606C177.984 157.889 180.124 154.511 178.493 151.752L153.442 109.383C151.262 105.696 147.104 103.408 142.587 103.408H70.1647C66.7867 103.408 64.6469 106.786 66.278 109.545L91.3286 151.911C93.5088 155.598 97.6673 157.889 102.184 157.889Z",
    fill: "#C0C1FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M101.443 156.5H176.967C180.415 156.5 182.6 153.052 180.937 150.236L155.367 106.991C153.143 103.222 148.907 100.892 144.288 100.892H68.7621C65.3142 100.892 63.1286 104.339 64.792 107.155L90.3621 150.401C92.5934 154.163 96.8354 156.5 101.443 156.5Z",
    stroke: "#6562CF",
    strokeWidth: 1.34579,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M100.426 156.556H238.335C239.789 156.556 240.967 157.735 240.967 159.189V159.77C240.967 161.224 239.789 162.402 238.335 162.402H100.426C98.972 162.402 97.7934 161.224 97.7934 159.77V159.189C97.7934 157.735 98.972 156.556 100.426 156.556Z",
    fill: "#D1D1FF",
    stroke: "#6562CF",
    strokeWidth: 1.61495,
    strokeMiterlimit: 10
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.da7018fb.svg";
export { ForwardRef as ReactComponent };